import {Component, OnInit} from '@angular/core';
import { FileSelectionComponent } from './file-selection/file-selection.component';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

@Component({
    selector: 'fmc-pdf-tools',
    templateUrl: './pdf-tools.component.html',
    styleUrls: ['./pdf-tools.component.scss'],
    standalone: true,
    imports: [FileUploadComponent, FileViewerComponent, FileSelectionComponent]
})
export class PdfToolsComponent implements OnInit {
  constructor() { }

  ngOnInit() {}
}
